import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';

import Loader from 'src/app/components/Loader';
import LayoutOffersCount from 'src/app/components/Layout/LayoutOffersCount';
import background from 'src/assets/images/background-login.jpg';
import { confirmAccount } from 'src/app/redux/actions/registration/confirmAccount';


class ConfirmAccountContainer extends React.PureComponent {

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(confirmAccount());
  }

  render() {
    const { redirection, location } = this.props;

    return (
      <LayoutOffersCount background={ background }>
        { redirection ? <Redirect to={ { pathname: '/', search: location.search } }/> : <Loader/> }
      </LayoutOffersCount>
    );
  }
}

ConfirmAccountContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  redirection: PropTypes.bool.isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired
  }).isRequired
};

const mapStateToProps = (store) => ({
  redirection: store.confirmAccountReducer.shouldRedirectToLogin
});

export default connect(mapStateToProps)(withRouter(ConfirmAccountContainer));
